<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="mx-3 pt-4 pb-2" >
                <v-col sm="6" md="2" class="py-0 my-0">
                    <client-selector :addAllOption="false" class="py-0 mb-1" ref="clientSelector" @getClients="v => items.clients = v" :is_national="2"></client-selector>
                </v-col>
                <v-col sm="6" md="2" class="py-0 my-0">
                    <v-autocomplete class="py-0 mb-1" item-value="value" item-text="name" v-model="search.criterion" :items="criterions" :label="$t('search.criterion')"></v-autocomplete>
                </v-col>
                <v-col sm="6" md="2" class="py-0 my-0">
                    <v-text-field class="py-0 mb-1" v-model="search.value" :label="$t('search.data_to_search')"></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="6" align="end" class="py-0" justify="center">

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="right white_highlight--text mr-2" :disabled="!can_mark_damaged" style="max-width: 40px !important; min-width: 40px !important" color="secondary" @click="damagedProduct">
                                <v-icon class="material-icons-outlined" small>error_outline</v-icon>
                            </v-btn>
                        </template>

                        <span>{{$t('search.damaged_stolen')}}</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="right white_highlight--text mr-2" :disabled="!can_download_label" style="max-width: 40px !important; min-width: 40px !important" color="secondary" @click="downloadLabel">
                                <v-icon class="material-icons-outlined" small>label</v-icon>
                            </v-btn>
                        </template>

                        <span>{{$t('search.download_label')}}</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="right white_highlight--text mr-2" style="max-width: 40px !important; min-width: 40px !important" color="secondary" @click="downloadInvoice">
                                <v-icon class="material-icons-outlined" small>description</v-icon>
                            </v-btn>
                        </template>

                        <span>{{$t('search.download_invoice')}}</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="right white_highlight--text mr-2" style="max-width: 40px !important; min-width: 40px !important" color="secondary" @click="editShipment">
                                <v-icon class="material-icons-outlined" small>edit</v-icon>
                            </v-btn>
                        </template>

                        <span>{{$t('search.edit')}}</span>
                    </v-tooltip>

                    <v-btn class="right white_highlight--text mr-2" color="secondary" @click="searchOrder">
                        {{ $t('search.search') }}
                        <v-icon class="px-1" small>search</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-card class="size_buttons">
                <v-row class="px-0 pt-6 mx-0" align="center" justify="center">
                    <!-- GENERAL DATA -->
                    <v-col cols="6">
                        <v-card class="ml-5 mr-1 size_left_card">
                            <v-row class="ml-5 mr-1 py-0 my-2" justify="center" align="center">
                                <v-col cols="12" class="py-0">
                                    <label class="blue_accent--text text-uppercase title">{{$t('search.general_data')}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="12" class="py-0">
                                    <label class="subsubtitle" style="line-height: 15px !important; display: block;">{{$t('search.consignee_policy')}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.order')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle">{{order.shipment.unique_order_number}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.warehouse')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle" v-if="search.criterion == 'fulfillment_eon'">{{order.w_name}}</label>
                                    <label class="subsubtitle" v-if="search.criterion != 'fulfillment_eon'">{{order.warehouse.name}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.shipping_service')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle">{{order.shipment.shipping_service}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.zone')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle">{{order.shipment.zone}}</label>
                                </v-col>
                            </v-row>
                            <span v-if="order.shipment.guides != undefined && order.shipment.guides != null">
                                <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center" v-for="(guide, i) of order.shipment.guides.split(',')" :key="i">
                                    <v-col cols="5" class="py-0" v-if="i == 0">
                                        <label class="subtitle">{{$t('search.shipment_number')}}</label>
                                    </v-col>
                                    <v-col cols="5" class="py-0" v-else-if="i > 0">
                                        <label class="subtitle"></label>
                                    </v-col>
                                    <v-col cols="7" class="py-0">
                                        <label class="subsubtitle">{{guide}}</label>
                                    </v-col>
                                </v-row>
                            </span>
                            <span v-else>
                                <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                    <v-col cols="5" class="py-0">
                                        <label class="subtitle">{{$t('search.shipment_number')}}</label>
                                    </v-col>
                                    <v-col cols="7" class="py-0">
                                        <label class="subtitle"></label>
                                    </v-col>
                                </v-row>
                            </span>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.buyer')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle">{{order.consignee.name}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.state')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle">{{order.consignee.state}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.municipality')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle">{{order.consignee.municipality}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.neighborhood')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle">{{order.consignee.neighborhood}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.address')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle">{{order.consignee.street}}, {{order.consignee.external_number}} {{order.consignee.internal_number}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.zipcode')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle">{{order.consignee.zipcode}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.phone')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle">{{order.consignee.phone}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.references')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle">{{order.consignee.comments}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.ext_zone')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle">{{order.shipment.ext_zone}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.packing')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle">{{order.shipment.sizes}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.weight')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle">{{order.shipment.weight }}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.order_type')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0" >
                                    <label class="subsubtitle" v-if="order.shipment.cod == true">{{$t('search.is_cod')}}</label>
                                    <label class="subsubtitle" v-if="order.shipment.cod == false">{{$t('search.is_prepaid')}}</label>
                                    <label class="subsubtitle" v-if="search.criterion == 'fulfillment_eon'">{{$t('search.is_prepaid')}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center" v-if="order.minutes != null">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.minutes_status')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle">{{order.minutes.status}} - ({{ order.minutes.date }})</label>
                                </v-col>
                            </v-row>

                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center" v-if="order.minutes != null">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.minutes_comments')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle">{{order.minutes.comments}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="center" align="center">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.total_cod')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0">
                                    <label class="subsubtitle">{{order.shipment.total}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-1 py-0 my-0" justify="end" align="end">
                                <v-col cols="5" class="py-0">
                                    <label class="subtitle">{{$t('search.products')}}</label>
                                </v-col>
                                <v-col cols="7" class="py-0" v-for="product of order.products" :key="product.id">
                                    <label class="subsubtitle">{{ product.quantity }} - ({{ product.sku }}) - {{ product.description }}</label>
                                </v-col>
                                <v-col cols="7" v-if="order.products.length == 0" class="py-0">
                                    <label class="subsubtitle"></label>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>

                    <!-- DELIVERY DETAILS -->
                    <v-col cols="6">
                        <v-card class="mr-5 ml-1 size_left_card_2_3">
                            <v-row class="px-0 mr-0 ml-5 py-0 my-2" justify="center" align="center">
                                <v-col cols="12" class="py-0">
                                    <label class="blue_accent--text text-uppercase title">{{$t('search.delivery_details')}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 mr-5 ml-5 py-0 my-1" justify="center" align="center">
                                <v-col cols="6" class="py-0" justify="start" align="start">
                                    <label>{{ $t('search.status')}}</label>
                                </v-col>
                                <v-col cols="6" class="py-0" justify="end" align="end">
                                    <label>{{ $t('search.date')}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 mr-7 ml-7 py-0 my-1" v-for="status of order.statuses" :key="status.id" style="border-bottom: 1px solid var(--v-accent-base); border-radius: 0px;" justify="center" align="center">
                                <v-col cols="9" class="py-0" justify="start" align="start">
                                    <label style="font-size: 14px;" class="subsubtitle" v-if="status.attempt_number != null"> {{status.status}} ({{ $t('search.attempt') }} {{ status.attempt_number }})  (<a :href="'https://www.google.com/maps?q=' + status.latitude + ',' + status.longitude" target="_blank">{{ $t('search.location') }}</a>) </label>
                                    <label style="font-size: 14px;" class="subsubtitle" v-else-if="status.attempt_number == null"> {{status.status}} </label>
                                </v-col>
                                <v-col cols="3" class="py-0" justify="end" align="end">
                                    <label style="font-size: 14px;" v-if="status.date == null"> {{ status.created_at.includes("T")? status.created_at.split('T')[0]: status.created_at.split(' ')[0] }} {{ status.created_at.includes("T")? status.created_at.split('T')[1].substring(0, 5) : status.created_at.split(' ')[1].substring(0, 5) }} </label>
                                    <label style="font-size: 14px;" v-else> {{ status.date }} </label>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="mr-5 ml-1 size_left_card_1_3">
                            <v-row class="px-0 mr-0 ml-5 py-0 my-2" justify="center" align="center">
                                <v-col cols="12" class="py-0">
                                    <label class="blue_accent--text text-uppercase title">{{$t('search.photographic_evidence')}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 mr-5 ml-5 py-0 my-1" justify="start" align="start">
                                <v-col cols="3" class="py-0 mb-3" v-for="img in images" :key="img.id">
                                    <v-btn @click="showImage(img.id)" style="min-height: 130px; min-width: 130px;" class="mx-0 px-0 my-0 py-0" flat>
                                        <v-img :src="img.url" height="130" width="130"></v-img>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
        
                </v-row>
            </v-card>
        </v-container>
        <v-dialog v-model="modal_show_img" persistent max-width="90%">
            <v-card >
                <v-card-title class="justify-center">
                    <v-row align="center" justify="center">
                        <h3 class="text-uppercase">
                            {{ $t('search.photographic_evidence') }}
                        </h3>
                    </v-row>
                    <v-btn class="right tools-view-height mx-1" outlined color="error" style="max-width: 30px !important; min-width: 30px !important" @click="modal_show_img = false; this.showed_img = ''">
                        <v-icon class="px-1" small>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="mt-4">
                    <v-img :src="this.showed_img" ></v-img>
                </v-card-text> 
                <div class="marker1"></div>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>

import JSZip from 'jszip';
import FileSaver from 'file-saver';
export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]},
        client: function(){
            return this.$store.state.clientId
        }
    },
    data(){
        return {
            numberFormat: new Intl.NumberFormat('en-us', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            search: {
                value: '',
                client_id: '',
                criterion: '',
            },
            can_download_label: false,
            can_mark_damaged: false,
            order: {
                statuses: {},
                shipment: {guides:''},
                consignee: {},
                products: [],
                minutes: [],
                charge: {},
                warehouse: {}
            },
            states: [],
            municipalities: [],
            value: true,
            criterions: [
                { name: this.$t("search.tracking_number"), value: "tn" }, 
                { name: this.$t("search.uon"), value: "uon" }, 
                { name: this.$t("search.fulfillment_eon"), value: "fulfillment_eon" }
            ],
            images: [],
            modal_show_img: false,
            showed_img: ''
        }
    },
    mounted(){
        this.$store.state.clientId = null;
        this.index();
        this.$store.state.module = "headers.search";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        index(){
            this.states = [];
            this.states_load = true;
            this.$http.get("https://locations.intech.mx/api/getStates/MX", {})
            .then((response) => {
                if(response.status === 200){
                    this.states = response.data
                    this.states_load = false;
                }
            }).finally(() => {
                this.states_load = false;
            });
        },
        searchOrder(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.get(this.$store.state.chronosApi + 'shipment/shipmentSearch/' + this.search.client_id + '/' + this.search.criterion + '/' + this.search.value, { headers: { Authorization: lsToken } })
            .then((response) => {
                if(response.data.success === true){
                    this.$store.state.loaderProps.visible = false;
                    
                    if(this.search.criterion != "fulfillment_eon"){
                        this.order.statuses = response.data.statuses;
                        this.order.shipment = response.data.shipment;
                        this.order.minutes = response.data.minutes;
                        this.order.charge = response.data.charge;
                        var now = new Date();
                        this.order.statuses.forEach(x => {
                            if(x.status == "READY"){
                                const date_3_months = new Date(x.created_at);
                                date_3_months.setMonth(date_3_months.getMonth() + 3);
                                
                                if (now > date_3_months) this.can_download_label = false;
                                else this.can_download_label = true;
                            }
                            else if(x.status == "RETURNED TO CHRONOS") this.can_mark_damaged = true;
                        })

                        this.order.shipment.products_weight = this.order.shipment.products_weight.split(",").map(Number).reduce((acc, n) => acc + n, 0);
                        this.order.shipment.products_weight.toFixed(2);

                        if(parseFloat(this.order.shipment.b_volumetric_weight) > parseFloat(this.order.shipment.products_weight)) this.order.shipment.weight = this.order.shipment.b_volumetric_weight.toString() + "KG";
                        else if(parseFloat(this.order.shipment.products_weight) > parseFloat(this.order.shipment.b_volumetric_weight)) this.order.shipment.weight = this.order.shipment.products_weight.toString() + "KG";
                        else this.order.shipment.weight = this.order.shipment.products_weight.toString() + "KG";

                        this.order.shipment.ext_zone = response.data.extZone == false ? "No Aplica" : "Aplica";
                        this.order.shipment.insurance = response.data.shipment.cod == true && response.data.shipment.total >= 6500 ? "Aplica" : "No Aplica";
                        if(response.data.shipment.width == null || response.data.shipment.height == null || response.data.shipment.length == null) this.order.shipment.sizes = "";
                        else this.order.shipment.sizes = response.data.shipment.width + "x" + response.data.shipment.height + "x" + response.data.shipment.length;
                        this.order.shipment.total = '$' + this.numberFormat.format(response.data.shipment.total);
                        this.order.consignee = response.data.consignee;
                        this.order.products = response.data.products;

                        this.$http.get(this.$store.state.chronosApi + 'shipment/files/' + this.order.shipment.id, { headers: { Authorization: lsToken } })
                        .then((res) => {
                            this.images = []

                            this.images = res.data.data;
                        })
                    } else {
                        this.order.shipment.unique_order_number = response.data.shipment.unique_order_number;
                        this.order.shipment.shipment_number = response.data.shipment.tracking_number;
                        this.order.shipment.shipping_service = response.data.shipment.shipping_service;
                        this.order.shipment.sizes = response.data.shipment.name;
                        this.order.consignee.name = response.data.shipment.consignee_name;
                        this.order.shipment.id = response.data.shipment.id;
                    
                        this.order.statuses = JSON.parse(response.data.shipment.status);
                        this.order.products = JSON.parse(response.data.shipment.products).products;
                    }

                    this.order.warehouse = response.data.warehouse;
                }
            })
            .catch((response) => {
                this.$store.state.loaderProps.visible = false;
                if(response.status !== 200){
                    this.snackbar = {
                        visible: true,
                        color: 'red',
                        text: this.$t('pendings.responses.error')
                    }
                }
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            });

        },
        downloadLabel: async function (){
            if(this.search.criterion == "fulfillment_eon"){
                await this.downloadExternalShipmentLabel(this.order);
            }
            else {
                var zip = new JSZip();
                let blobs = [];
                const urls = await this.getLabelUrls(this.order.shipment.id);

                if(this.order.shipment.shipping_service.toUpperCase() == 'OTRA'){ // add to zip all the attached files
                    if(urls.data[0].files.length > 0){
                        const url = {
                            name: this.order.shipment.shipment_number,
                            url: urls.data[0].files[urls.data[0].files.length - 1].url
                        }
                        const blob = await this.getLabelFiles(url, 'attached_file');
                        blobs.push(blob);
                    }
                }
                else{
                    for(var i = 0; i < urls.data[0].data.length; i++){
                        const blob = await this.getLabelFiles(urls.data[0].data[i], 'label');
                        blobs.push(blob);
                    }
                }

                if(blobs.length > 0){
                    blobs.forEach(x => {
                        zip.file(x.name, x.response.data);
                    });

                    this.$store.state.loaderProps.visible = false;
                    var t = this;
                    zip.generateAsync({type:"blob"}).then(function(content) {
                        FileSaver.saveAs(content, t.order.shipment.unique_order_number)
                    }, function(err){
                        console.log(err)
                    })
                }
            }
        },
        downloadExternalShipmentLabel: async function (order){
            this.$store.state.loaderProps.visible = true;
            // var zip = new JSZip();
            const lsToken = localStorage.getItem("access_token");
            const response = await this.$http.get(this.$store.state.chronosApi + 'external_shipment/get_labels_urls/' + order.shipment.id, {headers: {Authorization: lsToken}})
            var urls = ""
            
            if(typeof response.data.data == "string") urls = JSON.parse(response.data.data);
            else urls = response.data.data

            for(var i = 0; i < urls.length; i++){
                const file = await this.getExternalShipmentLabelFile(order.shipment.id, urls[i].index ?? 0, lsToken)

                if(file.data.code == 200) {
                    FileSaver.saveAs(file.data.success.arguments.file, file.data.success.arguments.filename);
                    order.labelDownloaded = true;
                }
                else {
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: this.$t('fulfillment_eon_in_process.download_label_error') + (i + 1)
                    };
                }
            }

            this.$store.state.loaderProps.visible = false;
        },
        getExternalShipmentLabelFile: async function (id, index, lsToken){
            const file = await this.$http.get(this.$store.state.chronosApi + 'external_shipment/download_label/' + id + '/' + index, {headers: {Authorization: lsToken}})
            return file
        },
        downloadInvoice(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.get(this.$store.state.chronosApi + 'shipment/getNote?id=' + this.order.shipment.id + '&format=PNG', {headers: {Authorization: lsToken}, responseType:'blob' })
            .then((response) => {
                // Get consginee data
                this.$store.state.loaderProps.visible = false;
                FileSaver.saveAs(response.data, this.order.shipment.shipment_number + ".png");
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })
        },
        getLabelFiles: async function(url, type){
            const lsToken = localStorage.getItem("access_token");
            if(type == 'label'){
                const blob = await this.$http.get(url, {headers: {Authorization: lsToken}, responseType:'blob' });
                return {response: blob, name: url.split("/")[5].split('.')[0] + '.png'};
            }
            else if(type == 'attached_file'){
                const blob = await this.$http.get(url.url, {headers: {Authorization: lsToken}, responseType:'blob' });
                return {response: blob, name: url.name + ".pdf"};
            }
        },
        getLabelUrls: async function (order){
            const lsToken = localStorage.getItem("access_token");

            const {data} = await this.$http.get(this.$store.state.chronosApi + 'shipment/getLabels?id=' + order, {headers: {Authorization: lsToken}});
            return data;
        },
        editShipment(){
            var type = this.order.shipment.cod == false ? "prepaid" : "cod"
            if(this.order.charge.last_status == "PLACED"){
                this.$router.push('pending-shipments/' + type + '/edit/' + this.order.shipment.id)
            }
            else if(this.order.charge.last_status != "PLACED"){
                this.$router.push('sent-shipments/' + type + '/edit/' + this.order.shipment.id)
            }
        },
        damagedProduct(){
            if(this.order.shipment.cod == false) this.$router.push("/shipments/prepaid/incidence/" + this.order.shipment.id);
            else this.$router.push("/shipments/cod/incidence/" + this.order.shipment.id);
        },
        showImage(img){
            this.modal_show_img = true;
            this.showed_img = this.images.find(x => x.id === img).url;
        }
    },
    watch: {
        '$store.state.clientId': function (){
            this.search.client_id = this.$store.state.clientId
        },
    }
}
</script>
<style>
.title {
    font-size: 16px;
    font-weight: bold;
}
.subtitle {
    font-size: 12px;
    font-weight: bold;
}
.subsubtitle {
    font-size: 12px;
}
</style>